import {TweenMax, TimelineMax, Linear} from 'gsap/all';

let countProjectsSlides = 1;

let interval = null;

let hidden;

let visibilityChange;

function changeSlide(data) {
	let $currentImage = $(`.top-block__img[data-item="${countProjectsSlides}"]`);

	let $nextImage;

	if (data) {
		countProjectsSlides = parseFloat(data);

		$nextImage = $(`.top-block__img[data-item="${countProjectsSlides}"]`);
	} else if (countProjectsSlides < $('.top-block__img').length) {
		countProjectsSlides++;
		$nextImage = $(`.top-block__img[data-item="${countProjectsSlides}"]`);
	} else if (countProjectsSlides === $('.top-block__img').length) {
		countProjectsSlides = 1;
		$nextImage = $(`.top-block__img[data-item="${countProjectsSlides}"]`);
	}

	new TimelineMax({
		onStart() {
			TweenMax.set([$nextImage], {x: '100%'});
			$nextImage.removeClass('is-hidden');
			$('.top-block__item-pagination').removeClass('is-active');
			$(`.top-block__item-pagination[data-item="${countProjectsSlides}"]`).addClass('is-active');
		},
		onComplete() {
			$currentImage.addClass('is-hidden');
			TweenMax.set([$currentImage], {clearProps: 'all'});
		},
	})
		.to($currentImage, 0.6, {
			x: '-100%',
			ease: Linear.easeNone,
		}, 0)
		.to($nextImage, 0.6, {
			x: '0%',
			ease: Linear.easeNone,
		}, 0);
}

function intervalManager(flag, animate, time) {
	if (flag) {
		interval = setInterval(animate, time);
	} else {
		clearInterval(interval);
	}
}

$('.top-block__item-pagination').on('click', (e) => {
	e.preventDefault();

	let $this = $(e.currentTarget);

	let id = $this.attr('data-item');

	intervalManager(false);
	changeSlide(id);
	intervalManager(true, changeSlide, 5000);
});

if (typeof document.hidden !== 'undefined') {
	hidden = 'hidden';
	visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
	hidden = 'msHidden';
	visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
	hidden = 'webkitHidden';
	visibilityChange = 'webkitvisibilitychange';
}

function handleVisibilityChange() {
	if (document[hidden] && $('.main-page').length) {
		intervalManager(false);
	} else if ($('.main-page').length) {
		intervalManager(true, changeSlide, 5000);
	}
}

if (typeof document.addEventListener === 'undefined' || hidden === undefined) {
	console.log('This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');
} else {
	document.addEventListener(visibilityChange, handleVisibilityChange, false);
}

$(window).on('load', () => {
	if ($('.main-page').length) {
		intervalManager(true, changeSlide, 5000);
	}
});
